var map = {
	"./Showreel.mp4": 5732,
	"./Showreel.webm": 84074,
	"./animate/glb/Test_2": 22569,
	"./animate/glb/Test_2.js": 22569,
	"./animate/glb/test_2.glb": 61483,
	"./dobroar/bg-laptop.png": 87103,
	"./dobroar/bg-mobile.png": 19802,
	"./dobroar/bg.png": 41638,
	"./dobroar/partner1.png": 75109,
	"./dobroar/partner2.png": 69305,
	"./dobroar/star.png": 59925,
	"./dobroar/stars.png": 51173,
	"./fonts/IBMPlexMono-Medium.ttf": 72831,
	"./fonts/IBMPlexMono-Regular.ttf": 28365,
	"./fonts/IBMPlexMono-SemiBold.ttf": 95297,
	"./fonts/IBMPlexMono-Text.ttf": 57295,
	"./fonts/Mulish-Regular.ttf": 71467,
	"./fonts/VelaSans-Bold.ttf": 93388,
	"./fonts/VelaSans-Medium.ttf": 22934,
	"./fonts/ZeroCool.ttf": 96422,
	"./merch/item_1.jpeg": 50379,
	"./merch/item_2.jpeg": 28070,
	"./merch/item_3.jpeg": 57805,
	"./merch/item_4.jpeg": 40994,
	"./merch/item_5.jpeg": 25249,
	"./merch/item_5_black.jpeg": 26665,
	"./merch/item_7.jpeg": 63010,
	"./merch/mainscreen.jpeg": 95859,
	"./merch/obj_1.jpeg": 98194,
	"./merch/obj_2.jpeg": 2998,
	"./merch/star.svg": 10021,
	"./nft/btrNft/image1.jpeg": 41719,
	"./nft/btrNft/logo.jpeg": 8542,
	"./nft/btrNft/mainscreen.jpeg": 58007,
	"./nft/btrNft/video1.mp4": 28705,
	"./nft/btrNft/video2.mp4": 6975,
	"./nft/dirtydrops/image1.jpeg": 9114,
	"./nft/dirtydrops/image2.jpeg": 34143,
	"./nft/dirtydrops/image3.jpeg": 60539,
	"./nft/dirtydrops/image4.jpeg": 84961,
	"./nft/dirtydrops/logo.jpeg": 10614,
	"./nft/dirtydrops/mainscreen.jpeg": 89043,
	"./nft/dirtydrops/video1.mp4": 12631,
	"./nft/dirtydrops/video2.mp4": 25829,
	"./nft/halloween/logo.jpeg": 52846,
	"./nft/halloween/mainscreen.jpeg": 15673,
	"./nft/halloween/video1.mp4": 80288,
	"./nft/halloween/video2.mp4": 73427,
	"./nft/halloween/video3.mp4": 69805,
	"./nft/halloween/video4.mp4": 6297,
	"./nft/halloween/video5.mp4": 35344,
	"./nft/halloween/video6.mp4": 45846,
	"./nft/interior/arrow.png": 82052,
	"./nft/interior/logo.jpeg": 89649,
	"./nft/interior/mainscreen.jpeg": 42303,
	"./nft/interior/slider_1/image_1.jpeg": 52937,
	"./nft/interior/slider_1/image_2.jpeg": 9071,
	"./nft/interior/slider_1/image_3.jpeg": 4830,
	"./nft/interior/slider_2/image_1.jpeg": 32989,
	"./nft/interior/slider_2/image_2.jpeg": 43920,
	"./nft/interior/slider_3/image_1.jpeg": 48290,
	"./nft/interior/slider_3/image_2.jpeg": 73453,
	"./nft/interior/video.mp4": 57354,
	"./nft/metafemhistory/i1.jpeg": 38676,
	"./nft/metafemhistory/i2.jpeg": 37338,
	"./nft/metafemhistory/i3.jpeg": 16964,
	"./nft/metafemhistory/i4.jpeg": 77716,
	"./nft/metafemhistory/i5.jpeg": 9423,
	"./nft/metafemhistory/logo.jpeg": 93036,
	"./nft/metafemhistory/mainscreen.jpeg": 75116,
	"./nft/newcityartist/car.jpeg": 68475,
	"./nft/newcityartist/logo.jpeg": 55076,
	"./nft/newcityartist/mainscreen.jpeg": 40242,
	"./nft/newcityartist/video1.mp4": 1067,
	"./nft/newcityartist/video2.mp4": 56791,
	"./nft/newcityartist/video3.mp4": 89523,
	"./nft/newcityartist/video4.mp4": 48142,
	"./nft/neweast/logo.jpeg": 31362,
	"./nft/neweast/mainscreen.jpeg": 23904,
	"./nft/neweast/video.mp4": 50892,
	"./nft/newnames/logo.jpeg": 29338,
	"./nft/newnames/mainscreen.jpeg": 93118,
	"./nft/newnames/video.mp4": 45287,
	"./pairs/bentley.png": 56200,
	"./pairs/dnevnik.png": 48631,
	"./pairs/gagagames.png": 87199,
	"./pairs/italy_co.png": 35044,
	"./pairs/lenfilm.png": 32951,
	"./pairs/museum.png": 21708,
	"./pairs/open_city.png": 8187,
	"./pairs/petersburg_diary.png": 73150,
	"./pairs/planetariy.png": 9635,
	"./pairs/pravitelstvo.png": 57087,
	"./pairs/rosatom.png": 58246,
	"./pairs/rumuseum.png": 28630,
	"./pairs/rzd.png": 76132,
	"./pairs/sobaka.png": 51088,
	"./projects/SerebryanoeOzherele/case.jpg": 34363,
	"./projects/SerebryanoeOzherele/image1.jpg": 68686,
	"./projects/SerebryanoeOzherele/image2.jpg": 90344,
	"./projects/SerebryanoeOzherele/mainscreen-mobile.jpg": 72893,
	"./projects/SerebryanoeOzherele/mainscreen.jpg": 29329,
	"./projects/aag/case.jpg": 53432,
	"./projects/aag/mainscreen-mobile.jpg": 42509,
	"./projects/aag/mainscreen.jpg": 69621,
	"./projects/aag/poster1.jpg": 98955,
	"./projects/aag/poster2.jpg": 36730,
	"./projects/aag/poster3.jpg": 17979,
	"./projects/aag/video1.mp4": 8936,
	"./projects/aag/video2.mp4": 98115,
	"./projects/aag/video3.mp4": 25957,
	"./projects/appkolpino/case.jpg": 85563,
	"./projects/appkolpino/image1.png": 14213,
	"./projects/appkolpino/image2.png": 20091,
	"./projects/appkolpino/image3.png": 35055,
	"./projects/appkolpino/logo.jpeg": 98231,
	"./projects/appkolpino/mainscreen.jpeg": 26779,
	"./projects/arka/case.jpg": 58974,
	"./projects/arka/image1.jpg": 60407,
	"./projects/arka/image2.jpg": 51208,
	"./projects/arka/mainscreen-mobile.jpg": 49471,
	"./projects/arka/mainscreen.jpg": 76246,
	"./projects/arrow-black.svg": 23793,
	"./projects/arrow-white.svg": 12231,
	"./projects/backtotheroots/case.jpg": 80706,
	"./projects/backtotheroots/landing.jpeg": 86221,
	"./projects/backtotheroots/logo.jpeg": 62454,
	"./projects/backtotheroots/mainscreen.jpeg": 85258,
	"./projects/bags/image1.jpg": 95840,
	"./projects/bags/image2.jpg": 35172,
	"./projects/bags/mainscreen.jpg": 47721,
	"./projects/bolshaya3d/1.mp4": 54632,
	"./projects/bolshaya3d/2.mp4": 62579,
	"./projects/bolshaya3d/3.mp4": 90311,
	"./projects/bolshaya3d/case.jpg": 13375,
	"./projects/bolshaya3d/mainscreen-mobile.jpg": 11629,
	"./projects/bolshaya3d/mainscreen.jpg": 79323,
	"./projects/bolshaya3d/ping.mp4": 69280,
	"./projects/bolshaya3d/poster1.jpg": 56351,
	"./projects/bolshaya3d/poster2.jpg": 26449,
	"./projects/bolshaya3d/poster3.jpg": 85557,
	"./projects/bolshaya3d/t34.mp4": 95456,
	"./projects/brodilkakolpino/case.jpg": 57634,
	"./projects/brodilkakolpino/image1.jpeg": 4304,
	"./projects/brodilkakolpino/image2.jpeg": 8651,
	"./projects/brodilkakolpino/image3.jpeg": 78047,
	"./projects/brodilkakolpino/image4.jpeg": 63678,
	"./projects/brodilkakolpino/logo.jpeg": 76001,
	"./projects/brodilkakolpino/mainscreen.jpeg": 17949,
	"./projects/brodilkakurortnyy/case.jpg": 44846,
	"./projects/brodilkakurortnyy/image1.jpeg": 60532,
	"./projects/brodilkakurortnyy/image2.jpeg": 97854,
	"./projects/brodilkakurortnyy/image3.jpeg": 44889,
	"./projects/brodilkakurortnyy/image4.jpeg": 27975,
	"./projects/brodilkakurortnyy/image5.jpeg": 86644,
	"./projects/brodilkakurortnyy/image6.jpeg": 3486,
	"./projects/brodilkakurortnyy/logo.jpeg": 10918,
	"./projects/brodilkakurortnyy/mainscreen.jpeg": 697,
	"./projects/brodilkamoscow/case.jpg": 41749,
	"./projects/brodilkamoscow/image1.jpeg": 58734,
	"./projects/brodilkamoscow/image2.jpeg": 60607,
	"./projects/brodilkamoscow/image3.jpeg": 55484,
	"./projects/brodilkamoscow/image4.jpeg": 35371,
	"./projects/brodilkamoscow/logo.jpeg": 64713,
	"./projects/brodilkamoscow/mainscreen.jpeg": 41112,
	"./projects/brodilkaviborg/case.jpg": 58113,
	"./projects/brodilkaviborg/image1.jpeg": 4081,
	"./projects/brodilkaviborg/image2.jpeg": 53446,
	"./projects/brodilkaviborg/image3.jpeg": 51197,
	"./projects/brodilkaviborg/image4.jpeg": 47482,
	"./projects/brodilkaviborg/logo.jpeg": 25252,
	"./projects/brodilkaviborg/mainscreen.jpeg": 79487,
	"./projects/btr/case.jpg": 74071,
	"./projects/btr/image1.png": 53110,
	"./projects/btr/image2.jpg": 98118,
	"./projects/btr/mainscreen-mobile.jpg": 83393,
	"./projects/btr/mainscreen.jpg": 94617,
	"./projects/btr/video.mp4": 927,
	"./projects/comicHero/case.jpg": 56805,
	"./projects/comicHero/mainscreen-mobile.jpg": 69080,
	"./projects/comicHero/mainscreen.jpg": 89492,
	"./projects/comicHero/poster1.jpg": 90438,
	"./projects/comicHero/video1.mp4": 53730,
	"./projects/dirtyDrops/case.jpg": 48399,
	"./projects/dirtyDrops/image1.png": 7471,
	"./projects/dirtyDrops/image2.jpg": 78184,
	"./projects/dirtyDrops/mainscreen-mobile.jpg": 91842,
	"./projects/dirtyDrops/mainscreen.jpg": 24140,
	"./projects/dirtyDrops/video.mp4": 78083,
	"./projects/discoverycity/case.jpg": 29913,
	"./projects/discoverycity/image1.jpeg": 67749,
	"./projects/discoverycity/image2.jpeg": 56859,
	"./projects/discoverycity/image3.jpeg": 54855,
	"./projects/discoverycity/image4.jpeg": 43714,
	"./projects/discoverycity/logo.jpeg": 36680,
	"./projects/discoverycity/mainscreen.jpeg": 22330,
	"./projects/discoverycity/poster.jpeg": 88183,
	"./projects/discoverycity/video.mp4": 19071,
	"./projects/dobro/case.jpg": 11469,
	"./projects/dobro/image1.jpg": 4050,
	"./projects/dobro/image2.jpg": 7263,
	"./projects/dobro/mainscreen-mobile.jpg": 27985,
	"./projects/dobro/mainscreen.jpg": 91983,
	"./projects/gazpromNCA/case.jpg": 42250,
	"./projects/gazpromNCA/image1.png": 27756,
	"./projects/gazpromNCA/image2.jpg": 43078,
	"./projects/gazpromNCA/mainscreen-mobile.jpg": 26956,
	"./projects/gazpromNCA/mainscreen.jpg": 27569,
	"./projects/gazpromNCA/video.mp4": 51590,
	"./projects/geniusloci/case.jpg": 3041,
	"./projects/geniusloci/image_1.jpeg": 83511,
	"./projects/geniusloci/image_2.jpeg": 12831,
	"./projects/geniusloci/image_3.jpeg": 55244,
	"./projects/geniusloci/image_4.jpeg": 3679,
	"./projects/geniusloci/image_5.jpeg": 68043,
	"./projects/geniusloci/logo.jpeg": 10004,
	"./projects/geniusloci/mainscreen.jpeg": 18172,
	"./projects/giri/case.jpg": 42015,
	"./projects/giri/image1.jpg": 92466,
	"./projects/giri/image2.jpg": 27602,
	"./projects/giri/mainscreen-mobile.jpg": 8032,
	"./projects/giri/mainscreen.jpg": 61013,
	"./projects/goroda-poyezda/case.jpg": 73195,
	"./projects/goroda-poyezda/image1.jpg": 29313,
	"./projects/goroda-poyezda/image2.jpg": 70768,
	"./projects/goroda-poyezda/mainscreen-mobile.jpg": 93142,
	"./projects/goroda-poyezda/mainscreen.jpg": 4153,
	"./projects/grandrims/case.jpg": 89706,
	"./projects/grandrims/image1.jpg": 53846,
	"./projects/grandrims/image2.jpg": 14763,
	"./projects/grandrims/mainscreen-mobile.jpg": 86618,
	"./projects/grandrims/mainscreen.jpg": 72325,
	"./projects/guidekur/case.jpg": 99975,
	"./projects/guidekur/logo.jpeg": 41732,
	"./projects/guidekur/mainscreen.jpeg": 7195,
	"./projects/guidekur/video.mp4": 97907,
	"./projects/hilkov/case.jpg": 19635,
	"./projects/hilkov/image1.jpg": 64720,
	"./projects/hilkov/image2.jpg": 99438,
	"./projects/hilkov/mainscreen-mobile.jpg": 75164,
	"./projects/hilkov/mainscreen.jpg": 3952,
	"./projects/hilkovApp/case.jpg": 61957,
	"./projects/hilkovApp/image1.jpg": 89711,
	"./projects/hilkovApp/image2.jpg": 31779,
	"./projects/hilkovApp/mainscreen-mobile.jpg": 17578,
	"./projects/hilkovApp/mainscreen.jpg": 46074,
	"./projects/hydrocosmos/case.jpg": 92769,
	"./projects/hydrocosmos/image1.jpg": 73254,
	"./projects/hydrocosmos/image2.jpg": 52654,
	"./projects/hydrocosmos/image2.png": 40723,
	"./projects/hydrocosmos/mainscreen.jpg": 9470,
	"./projects/hydrocosmos/mainscreen1.jpg": 79002,
	"./projects/kdc/case.jpg": 66934,
	"./projects/kdc/image1.png": 20725,
	"./projects/kdc/image2.png": 23529,
	"./projects/kdc/logo.jpeg": 94384,
	"./projects/kdc/mainscreen.jpeg": 82883,
	"./projects/khraniteli/case.jpg": 59056,
	"./projects/khraniteli/image1.jpg": 97087,
	"./projects/khraniteli/image2.jpg": 39554,
	"./projects/khraniteli/image3.jpg": 71900,
	"./projects/khraniteli/mainscreen-mobile.jpg": 50418,
	"./projects/khraniteli/mainscreen.jpg": 68697,
	"./projects/khraniteli3d/case.jpg": 8824,
	"./projects/khraniteli3d/cosmo.mp4": 21667,
	"./projects/khraniteli3d/mainscreen-mobile.jpg": 13036,
	"./projects/khraniteli3d/mainscreen.jpg": 81882,
	"./projects/khraniteli3d/ping.mp4": 80853,
	"./projects/khraniteli3d/t34.mp4": 78341,
	"./projects/koporye/case.jpg": 91520,
	"./projects/koporye/image1.jpeg": 61507,
	"./projects/koporye/image2.jpeg": 72258,
	"./projects/koporye/logo.jpeg": 4521,
	"./projects/koporye/mainscreen.jpeg": 90002,
	"./projects/koporye/poster.jpeg": 55663,
	"./projects/koporye/video.mp4": 41056,
	"./projects/ladoga/appvideo.mp4": 80041,
	"./projects/ladoga/case.jpg": 55066,
	"./projects/ladoga/logo.jpeg": 59102,
	"./projects/ladoga/mainscreen.jpeg": 7852,
	"./projects/ladoga/phones.jpeg": 41994,
	"./projects/letnySad/case.jpg": 93507,
	"./projects/letnySad/image1.jpg": 85561,
	"./projects/letnySad/image2.jpg": 36470,
	"./projects/letnySad/mainscreen-mobile.jpg": 29278,
	"./projects/letnySad/mainscreen.jpg": 85850,
	"./projects/memoGorodAnimate/case.jpg": 5153,
	"./projects/memoGorodAnimate/mainscreen-mobile.jpg": 70564,
	"./projects/memoGorodAnimate/mainscreen.jpg": 53088,
	"./projects/memoGorodAnimate/poster1.jpg": 30600,
	"./projects/memoGorodAnimate/poster2.jpg": 13079,
	"./projects/memoGorodAnimate/poster3.jpg": 6993,
	"./projects/memoGorodAnimate/video1.mp4": 28718,
	"./projects/memoGorodAnimate/video2.mp4": 88681,
	"./projects/memoGorodAnimate/video3.mp4": 98841,
	"./projects/memoMariinskiy/case.jpg": 14463,
	"./projects/memoMariinskiy/image1.jpg": 93200,
	"./projects/memoMariinskiy/mainscreen-mobile.jpg": 60291,
	"./projects/memoMariinskiy/mainscreen.jpg": 34938,
	"./projects/memoMariinskiy/poster.jpg": 38894,
	"./projects/memoMariinskiy/video.mp4": 24304,
	"./projects/memoVsevAnimate/case.jpg": 43931,
	"./projects/memoVsevAnimate/mainscreen-mobile.jpg": 61711,
	"./projects/memoVsevAnimate/mainscreen.jpg": 33130,
	"./projects/memoVsevAnimate/poster1.jpg": 80984,
	"./projects/memoVsevAnimate/poster2.jpg": 2476,
	"./projects/memoVsevAnimate/video1.mp4": 31136,
	"./projects/memoVsevAnimate/video2.mp4": 62641,
	"./projects/memovsev/case.jpg": 85368,
	"./projects/memovsev/image1.jpg": 76629,
	"./projects/memovsev/image2.jpg": 11434,
	"./projects/memovsev/mainscreen-mobile.jpg": 17066,
	"./projects/memovsev/mainscreen.jpg": 52709,
	"./projects/mymoscow/book_1.jpeg": 54825,
	"./projects/mymoscow/book_2.jpeg": 38466,
	"./projects/mymoscow/case.jpg": 18658,
	"./projects/mymoscow/image_create.jpeg": 4172,
	"./projects/mymoscow/image_site_1.jpeg": 87664,
	"./projects/mymoscow/image_site_2.jpeg": 85982,
	"./projects/mymoscow/logo.jpeg": 11157,
	"./projects/mymoscow/logoimg.jpeg": 22067,
	"./projects/mymoscow/mainscreen.jpeg": 30434,
	"./projects/mymoscow/site.jpeg": 76696,
	"./projects/mymoscow/video.mp4": 66202,
	"./projects/myviborg/appvideo.mp4": 72600,
	"./projects/myviborg/logo.jpeg": 67069,
	"./projects/myviborg/mainscreen.jpeg": 70082,
	"./projects/myviborg/phones.png": 40396,
	"./projects/nca/case.jpg": 27698,
	"./projects/nca/image1.jpg": 95264,
	"./projects/nca/image2.jpg": 16191,
	"./projects/nca/mainscreen.jpg": 28094,
	"./projects/nca/mainscreenMobile.jpg": 3123,
	"./projects/nevskyRunner/case.jpg": 6369,
	"./projects/nevskyRunner/image1.jpg": 68428,
	"./projects/nevskyRunner/image2.jpg": 95232,
	"./projects/nevskyRunner/mainscreen-mobile.jpg": 92055,
	"./projects/nevskyRunner/mainscreen.jpg": 77944,
	"./projects/publicart/case.jpg": 64985,
	"./projects/publicart/image1.jpeg": 6711,
	"./projects/publicart/image2.jpeg": 17471,
	"./projects/publicart/image3.jpeg": 89334,
	"./projects/publicart/image4.jpeg": 15720,
	"./projects/publicart/logo.jpeg": 79690,
	"./projects/publicart/mainscreen.jpeg": 66713,
	"./projects/setka/case.jpg": 66775,
	"./projects/setka/image1.jpg": 52718,
	"./projects/setka/image2.jpg": 30652,
	"./projects/setka/mainscreen.jpg": 65243,
	"./projects/setka/mainscreenMobile.jpg": 3621,
	"./projects/streetart/box.jpeg": 81721,
	"./projects/streetart/case.jpg": 26989,
	"./projects/streetart/image1.jpeg": 63212,
	"./projects/streetart/image2.jpeg": 90435,
	"./projects/streetart/logo.jpeg": 50034,
	"./projects/streetart/mainscreen.jpeg": 4530,
	"./projects/sujda/case.jpg": 67648,
	"./projects/sujda/image1.jpg": 38554,
	"./projects/sujda/image2.jpg": 4573,
	"./projects/sujda/mainscreen-mobile.jpg": 55739,
	"./projects/sujda/mainscreen.jpg": 1027,
	"./projects/verniyPut/case.jpg": 67639,
	"./projects/verniyPut/image1.jpg": 68906,
	"./projects/verniyPut/image2.jpg": 2563,
	"./projects/verniyPut/mainscreen-mobile.jpg": 94067,
	"./projects/verniyPut/mainscreen.jpg": 29188,
	"./projects/vita/case.jpg": 155,
	"./projects/vita/image1.jpg": 98966,
	"./projects/vita/image2.jpg": 16427,
	"./projects/vita/mainscreen-mobile.jpg": 52713,
	"./projects/vita/mainscreen.jpg": 30067,
	"./projects/vsevolozhsk/case.jpg": 62008,
	"./projects/vsevolozhsk/image1.jpg": 10193,
	"./projects/vsevolozhsk/image2.jpg": 53332,
	"./projects/vsevolozhsk/mainscreen-mobile.jpg": 4216,
	"./projects/vsevolozhsk/mainscreen.jpg": 23439,
	"./projects/webar/arrow.png": 72405,
	"./projects/webar/case.jpg": 40227,
	"./projects/webar/ellipse-1.png": 54098,
	"./projects/webar/ellipse-2.png": 64729,
	"./projects/webar/img1.jpg": 9639,
	"./projects/webar/img2.jpg": 69758,
	"./projects/webar/mainscreen.jpeg": 91415,
	"./projects/webar/star.png": 72989,
	"./projectsImg/gidro.png": 81752,
	"./projectsImg/goroda.png": 69156,
	"./projectsImg/ncd.png": 41368,
	"./projectsImg/train.png": 22435,
	"./rumuseum.png": 89263,
	"./services/app-tab/apps.jpg": 59218,
	"./services/app_1.jpg": 95098,
	"./services/app_2.jpg": 44728,
	"./services/app_3.jpg": 7716,
	"./services/app_4.jpg": 8338,
	"./services/ar-tab/ar.jpg": 40704,
	"./services/ar-tab/graph.jpg": 79009,
	"./services/ar-tab/unity.jpg": 57099,
	"./services/ar-tab/webar.jpg": 65169,
	"./services/ar_1.jpg": 80316,
	"./services/ar_2.jpg": 69211,
	"./services/ar_3.jpg": 91852,
	"./services/game-tab/artefact.jpg": 66016,
	"./services/game-tab/brodilky.jpg": 63147,
	"./services/game-tab/comix.jpg": 19602,
	"./services/game-tab/hranitely.jpg": 65711,
	"./services/game-tab/individual.jpg": 27343,
	"./services/game-tab/memo.jpg": 8693,
	"./services/game_1.jpg": 94278,
	"./services/game_2.jpg": 39055,
	"./services/game_3.jpg": 78704,
	"./services/graph-tab/graph_1.jpg": 85491,
	"./services/graph-tab/graph_2.jpg": 666,
	"./services/graph_1.jpg": 93803,
	"./services/graph_2.jpg": 23627,
	"./services/graph_3.jpg": 38615,
	"./services/web-tab/audit.jpg": 49246,
	"./services/web-tab/shops.jpg": 49661,
	"./services/web-tab/sites.jpg": 79574,
	"./services/web_1.jpg": 50661,
	"./services/web_2.jpg": 42533,
	"./services/web_3.jpg": 34188,
	"./services/web_4.jpg": 87117,
	"./showreel.jpg": 39031,
	"./svg/arrow-black.svg": 65364,
	"./svg/arrow-black_hover.svg": 53718,
	"./svg/arrow.svg": 92651,
	"./svg/arrow_link_PushKeeen.svg": 77664,
	"./svg/arrow_link_desktop.svg": 95766,
	"./svg/arrow_link_tablet.svg": 87491,
	"./svg/arrow_more.svg": 66278,
	"./svg/arrow_up.svg": 95215,
	"./svg/bracket.svg": 71680,
	"./svg/burger.svg": 2014,
	"./svg/burger_close.svg": 43261,
	"./svg/circle_button.svg": 42126,
	"./svg/circle_button_hover.svg": 53866,
	"./svg/clip.svg": 71333,
	"./svg/clipBreif.svg": 14925,
	"./svg/close.svg": 15103,
	"./svg/fullscreen.svg": 30281,
	"./svg/mobile/arrow-white.svg": 76644,
	"./svg/mobile/arrow.svg": 43419,
	"./svg/mobile/burger.svg": 4429,
	"./svg/mobile/circle_button_hover.svg": 56385,
	"./svg/mobile/star.svg": 60086,
	"./svg/mobile/star_button_hover.svg": 46353,
	"./svg/slogan_arrow.svg": 12154,
	"./svg/slogan_star.svg": 92258,
	"./svg/star_button.svg": 6243,
	"./svg/star_button_hover.svg": 31858
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 97173;